'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _taJsToolbox = require('ta-js-toolbox');

var _d3Request = require('d3-request');

var _d3Collection = require('d3-collection');

var _taReactGtm = require('ta-react-gtm');

var _taReactGtm2 = _interopRequireDefault(_taReactGtm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Component to track visits to a website, accessing the Newsnet API for all
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * tracking information. Currently supports GTM, WEMF and Webseismo.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Additional Providers need to be added separately.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module Polymorphic Tracking
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @version 1.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Loading states.
 *
 * @enum
 * @type {string}
 * @private
 */
var LOADING = 'loading',
    ERROR = 'error',
    READY = 'ready';

/**
 * @param {string=} props.articleId The article ID of the link article in
 * the CD. If not available will assume that content is being loaded in an
 * iframe.
 * @extends React.PureComponent
 */

var PolymorphicTracking = function (_React$PureComponent) {
  _inherits(PolymorphicTracking, _React$PureComponent);

  function PolymorphicTracking(props) {
    _classCallCheck(this, PolymorphicTracking);

    /**
     * The timestamp for cache-busting the tracking pixels.
     * @type {number}
     * @private
     */
    var _this = _possibleConstructorReturn(this, (PolymorphicTracking.__proto__ || Object.getPrototypeOf(PolymorphicTracking)).call(this, props));

    _this.loadTimestamp = Date.now();

    /**
     * Component state
     * @type {object}
     * @private
     */
    _this.state = {
      loadingState: LOADING
    };
    return _this;
  }

  _createClass(PolymorphicTracking, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state.loadingState === LOADING || this.state.loadingState === ERROR) {
        return null;
      }

      if (this.state.loadingState === READY) {
        return _react2.default.createElement(
          'div',
          { className: 'tracking' },
          this.state.gtmArticleData.map(function (tracker, index) {
            return _react2.default.createElement(_taReactGtm2.default, _extends({ gtmId: _this2.state.gtmId }, tracker, { key: index }));
          })
        );
      }
    }

    /**
     * Called after component has been mounted. This should only be called
     * once within the component lifecycle, even with state and props changing.
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var hostdomain = (0, _taJsToolbox.parseHostname)().publicationDomain;

      if (hostdomain === 'localhost') {
        hostdomain = 'tagesanzeiger.ch';
      }

      var articleIdFragment = '';
      if (this.props.articleId) {
        articleIdFragment += '/articles/' + this.props.articleId;
      }

      (0, _d3Request.json)('//mobile2.' + hostdomain + '/api' + articleIdFragment + '/external_services', function (error, data) {
        //region Error Handling
        if (error) {
          console.group('Polymorphic Tracking');
          console.warn('Data could not be loaded from the Newsnet API.');
          console.groupEnd();
          _this3.setState({
            loadingState: ERROR
          });
          return;
        }
        //endregion

        // Do something with the data
        var nestedTrackers = (0, _d3Collection.nest)().key(function (d) {
          return d.provider;
        }).map(data.statistics);

        //region WEMF (tracking pixels)
        if (_this3.props.articleId && nestedTrackers.has('wemf')) {
          nestedTrackers.get('wemf').map(function (tracker) {
            // Default tracking URL – mobile version
            var baseTrackerUrl = tracker.url;
            var contentWidth = window.innerWidth;
            // Adapt to content width.
            // This is obviously not entirely side-effect free, but we will
            // assume that a user typically doesn't resize their browser
            // window.
            if (contentWidth > 600) {
              baseTrackerUrl = tracker.ipad_url;
            }
            if (contentWidth > 900) {
              baseTrackerUrl = tracker.desktop_url;
            }

            var completeUrl = baseTrackerUrl + '?r=' + encodeURIComponent(document.referrer) + '&d=' + _this3.loadTimestamp;
            PolymorphicTracking.trackWithImage(completeUrl);
          });
        }
        //endregion

        //region Webseismo (tracking pixels)
        if (_this3.props.articleId && nestedTrackers.has('webseismo')) {
          nestedTrackers.get('webseismo').map(function (tracker) {
            var baseTrackerUrl = tracker.url_webapp;

            var contentWidth = window.innerWidth;

            if (contentWidth > 600) {
              baseTrackerUrl = tracker.url_tablet;
            }

            if (contentWidth > 900) {
              baseTrackerUrl = tracker.url_desktop;
            }

            var completeUrl = baseTrackerUrl + '?nocache=' + _this3.loadTimestamp;
            PolymorphicTracking.trackWithImage(completeUrl);
          });
        }
        //endregion

        //region GTM
        // This always tracks.
        _this3.setState({
          loadingState: READY,
          gtmArticleData: nestedTrackers.get('gtm') || [{
            pagetype: 'embedded content',
            category: 'interactive'
          }],
          gtmId: data.configs.gtm_id
        });
        //endregion
      });
    }

    /**
     * Track a visit using an image.
     *
     * @param {string} src The URL of the tracking pixel to use as the image
     * source.
     */

  }], [{
    key: 'trackWithImage',
    value: function trackWithImage(src) {
      // Load the image source URL without actually creating a image DOM element
      // (which, since it's invisible, isn't necessary anyway).
      var image = new Image();
      image.src = src;
    }
  }]);

  return PolymorphicTracking;
}(_react2.default.PureComponent);

exports.default = PolymorphicTracking;


PolymorphicTracking.propTypes = {
  articleId: _react2.default.PropTypes.string
};

PolymorphicTracking.defaultProps = {};


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-polymorphic-tracking/dist/index.js
// module id = 199
// module chunks = 0